<div class="form-control-inner">
  <div class="form-control-label" [innerHtml]="label"></div>
  <ng-content></ng-content>
</div>
